// extracted by mini-css-extract-plugin
module.exports = {"oldPrice":"old-price_oldPrice__T43_b"};